<script lang="ts">
  import '../app.css';
  import { page } from '$app/state';
  import type Lenis from 'lenis';
  import { gsap } from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';
  import Navbar from '$components/Navbar.svelte';
  import Footer from '$components/Footer.svelte';
  import ScrollToTopButton from '$components/ScrollToTopButton.svelte';
  import { m } from '$lib/paraglide/messages.js';

  gsap.registerPlugin(ScrollTrigger);

  let { children } = $props();
  let pageRef: HTMLDivElement | undefined;
  let lenis = $state<Lenis>();

  $effect(() => {
    let disposed = false;
    const tickerCallback = (time: number) => lenis?.raf(time * 1000);

    void import('lenis').then(({ default: Lenis }) => {
      if (disposed) return;

      lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(tickerCallback);
      gsap.ticker.lagSmoothing(0);
    });

    return () => {
      disposed = true;
      lenis?.destroy();
      gsap.ticker.remove(tickerCallback);
    };
  });

  $effect(() => {
    // react to page navigation
    const hash = page.url.hash;
    if (lenis) {
      if (hash) {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          setTimeout(() => lenis?.scrollTo(el, { offset: -64 }), 50);
        }
      } else {
        lenis.scrollTo(0, { immediate: true });
      }
    }
    ScrollTrigger.refresh();
  });
</script>

<svelte:head>
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Iter Global Consulting" />
  <meta property="og:title" content={m.home_title()} />
  <meta property="og:description" content={m.home_description()} />
  <meta property="og:image" content="https://itergc.com/social/og.png" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={m.home_title()} />
  <meta name="twitter:description" content={m.home_description()} />
  <meta name="twitter:image" content="https://itergc.com/social/og.png" />
</svelte:head>

<div class="min-h-[100dvh] bg-parchment">
  <Navbar />
  <div bind:this={pageRef}>
    {@render children()}
    <Footer />
  </div>
  <ScrollToTopButton />
</div>
